(() => {
  if (window.LucienRevealStack && typeof window.LucienRevealStack.init === 'function') {
    window.LucienRevealStack.init();
    return;
  }

  const STACK_SELECTOR = '[data-lucien-reveal-stack]';
  const ITEM_SELECTOR = '[data-lucien-reveal-item]';

  const prepareStack = (stack) => {
    if (!stack || stack.dataset.lucienRevealReady === 'true') return;

    stack.dataset.lucienRevealReady = 'true';
    stack.querySelectorAll(ITEM_SELECTOR).forEach((item, index) => {
      item.style.setProperty('--lucien-reveal-index', index);
    });
  };

  const revealStack = (stack) => {
    prepareStack(stack);
    stack.classList.add('is-lucien-reveal-visible');
  };

  const init = (root = document) => {
    const stacks = Array.from(root.querySelectorAll(STACK_SELECTOR));

    if (root.matches && root.matches(STACK_SELECTOR)) {
      stacks.unshift(root);
    }

    stacks.forEach(prepareStack);

    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      stacks.forEach(revealStack);
      return;
    }

    const observer = new IntersectionObserver(
      (entries, currentObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          revealStack(entry.target);
          currentObserver.unobserve(entry.target);
        });
      },
      {
        threshold: 0.28,
        rootMargin: '0px 0px -18% 0px',
      }
    );

    stacks.forEach((stack) => {
      if (stack.classList.contains('is-lucien-reveal-visible')) return;
      observer.observe(stack);
    });
  };

  window.LucienRevealStack = { init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
